import script from "./nyTit.vue?vue&type=script&setup=true&lang=js"
export * from "./nyTit.vue?vue&type=script&setup=true&lang=js"

import "./nyTit.vue?vue&type=style&index=0&id=a773ae6e&lang=less&scoped=true"
script.__scopeId = "data-v-a773ae6e"

export default script